import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg navbar-dark bg_color_primary fixed-top d-flex justify-content-between",
  style: {"background-color":"#00274c"}
}
const _hoisted_2 = { class: "navbar-nav col-4 align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-brand" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-4 d-flex justify-content-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 d-flex justify-content-center" }, null, -1)

import { useRoot } from '@/stores/root';
    import { storeToRefs } from 'pinia';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavBar',
  setup(__props) {

    const rootState = useRoot();
    const { getSelectedSite, getSelectedSiteName } = storeToRefs(rootState);

    const toggleSidebar = () =>
        rootState.showSidebar = !rootState.showSidebar


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "text-white bg_color_primary_light rounded-circle p-2" }, [
        _createElementVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-toggle": "collapse",
          "data-target": ".collapse",
          role: "button",
          style: {"display":"block"},
          href: "#",
          onClick: toggleSidebar
        }, _hoisted_4)
      ]),
      _createElementVNode("a", _hoisted_5, [
        _createElementVNode("img", {
          class: "mx-auto its-logo",
          src: 'short-its-logo.png'
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, " Zoom Phone Safety Calls | " + _toDisplayString(_unref(getSelectedSiteName)), 1),
    _hoisted_8
  ]))
}
}

})